import { useFormikContext } from "formik";
import type { OrganizationCloseStage } from "@common/types/organizationCloseStage";
import { DetailsAccordionItem } from "@design-system/Accordion/DetailsAccordionItem";
import { VStack } from "@design-system/VStack/VStack";
import { DeadlineField } from "../DeadlineField";
import { EstimateField } from "../EstimateField";
import { AssigneeRoleField } from "./AssigneeRoleField";
import { StageField } from "./StageField";
import { TemplateAssigneeSlot } from "./TemplateAssigneeSlot";
import type { TemplateTaskDetailsValues } from "./templateTaskDetails.schema";

interface TemplateTaskDetailsSectionProps {
    sortedStages: OrganizationCloseStage[];
}

export const TemplateTaskDetailsSection = ({
    sortedStages,
}: TemplateTaskDetailsSectionProps) => {
    const formik = useFormikContext<TemplateTaskDetailsValues>();

    return (
        <DetailsAccordionItem value="details" label="Details">
            <VStack gap={4}>
                <AssigneeRoleField />
                <TemplateAssigneeSlot />
                <DeadlineField
                    value={formik.values.externalDeadline}
                    anchor={formik.values.deadlineAnchor}
                    onChange={(value) => {
                        void formik.setFieldValue("externalDeadline", value);
                        if (value === null) {
                            void formik.setFieldValue("deadlineAnchor", null);
                        }
                    }}
                />
                <EstimateField
                    value={formik.values.estimatedTime}
                    onChange={(value) => {
                        void formik.setFieldValue("estimatedTime", value);
                    }}
                />
                <StageField sortedStages={sortedStages} />
            </VStack>
        </DetailsAccordionItem>
    );
};
